// Utility to normalize goalType from URL parameters
// URLs use "un-sdg" and "eu-sdg", but internally we use "un" and "eu"
import { GoalType } from './apiRoutes';

export function normalizeGoalType(goalType: string | undefined | null): GoalType {
  if (!goalType) return 'un';
  if (goalType === 'eu-sdg' || goalType === 'eu') return 'eu';
  if (goalType === 'un-sdg' || goalType === 'un') return 'un';
  // Legacy support: map old "global" URLs to "un"
  if (goalType === 'global-sdg' || goalType === 'global') return 'un';
  return 'un'; // default
}

export function goalTypeToUrl(goalType: GoalType): string {
  return goalType === 'eu' ? 'eu-sdg' : 'un-sdg';
}

